module.exports = "/images/footer-logo@2x.png?17680479bc4dd43e55b36b1c454fdeef";